export default __webpack_public_path__ + "static/media/dgm04-Enterprise-Data-Management-23-9-2015.4de69854.pdf";